import FilterItemBase from '../../base'
import { size } from 'lodash-es'
import { HOUSE_FILTER_ALIAS } from '@config'
import FilterItemNormal from '../../base/normal'
import useItem from '../useItem'

export default function FilterBedroom() {

  const {
    textLabel,
    routeData,
    viewData,
    isLoading,
    value,
    state,
    resetValue,
    changeHandle,
    clearHandle,
    confirmHandle
  } = useItem({
    text: 'Bed',
    slugKey: 'bedroom',
    houseRouteKey: 'bedroom',
    alias: HOUSE_FILTER_ALIAS.bedroom
  })

  return (
    <FilterItemBase
      text={textLabel}
      popupTitle='Beds'
      active={!!size(routeData)}
      totals={viewData && viewData.totals}
      isLoading={isLoading}
      onClear={clearHandle}
      onClose={resetValue}
      onConfirm={confirmHandle}
    >
      {viewData && <FilterItemNormal value={value} data={viewData} state={state} onChange={changeHandle}></FilterItemNormal>}
    </FilterItemBase>
  )
}